import { SpinRecordBuilder } from "slotworks/integration/revolver/builders/records/spin-record-builder";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import Record from "slotworks/model/gameplay/records/record";
import revolverModel from "slotworks/integration/revolver/model/revolver-model";
import { SpinResponseSchema } from "slotworks/integration/revolver/schema/spin-record-schema";
import slotDefinition from "slotworks/model/slot-definition";
import Point from "slotworks/utils/geom/point";
import G288SpinRecord from "integration/spin-record";
import G288FreespinRecord from "integration/freespin-record";

class G288SpinRecordBuilder extends SpinRecordBuilder {

    public build(gameplay: Gameplay, data: any): Record[] {
        let spinResponse: SpinResponseSchema;
        if (data && data.data) {
            spinResponse = data.data as SpinResponseSchema;
        }
        
        const gameData = (spinResponse.RESULTS.eval as any).gameData as GameData;
        if(gameData && gameData.stackFeatureActive) {
            this.processStackFeatureReels(spinResponse);            
        }
        const records = super.build(gameplay, data);

        if(records.length > 0) {
            const record = records[0] as G288SpinRecord | G288FreespinRecord;

            if(gameData && gameData.stackFeatureActive) {
                record.stackAddFeatureTriggered = true;
                record.stackAddFeatureSymbol = record.grid[0][0];
            }

            if(revolverModel.isSpin(spinResponse.RESULTS.game) && revolverModel.isFreespin(spinResponse.RESULTS.next_game)) {
                record.freespinsTriggered = true;
                const nextState = (spinResponse.RESULTS as any).next_game_state as NextGameState;
                if(nextState) {
                    record.freespinsWon = nextState.remain || nextState.total
                }
            } else if(spinResponse.RESULTS.state && spinResponse.RESULTS.state.is_retrigger && spinResponse.RESULTS.state.retriggers > 0) {
                (record as G288FreespinRecord).retriggerFreespins = true;
            }
        }

        return records;
    }

    private processStackFeatureReels(scema: SpinResponseSchema) {
        const aperture = scema.RESULTS.eval.aperture;
        const reelModifiers = (scema.RESULTS.eval as any).reelModifiers as ReelModifier[];
        if(aperture && reelModifiers) {
            reelModifiers.forEach(modifier => {
                const point = this.getGridPosition(modifier.position);
                aperture[point.x][point.y + 1] = modifier.symbol;
            });
        }
    }

    private getGridPosition(position: number) {
        let positionIndex = 0;
        for (let x = 0; x < slotDefinition.matrixGrid.length; x++) {
            const col = slotDefinition.matrixGrid[x];
            for (let y = 0; y < col; y++) {
                positionIndex++;
                
                if (positionIndex === position) {
                    return new Point(x, y);
                }
            }
        }
    }

}

export default new G288SpinRecordBuilder;

interface GameData {
    stackFeatureActive: boolean;
}

interface ReelModifier {
    position: number;
    symbol: string;
}

interface NextGameState {
    game: string;
    is_complete: boolean;
    remain: number;
    retriggers: number;
    rounds: number;
    spin_pending: boolean;
    spins: number;
    total: number;
    total_win_cash: number;
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/integration/builders/spin-record-builder.ts